import { useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { defaultEQM4010_R01Filter, useEQM4010_R01Store } from "./Store_EQM4010_R01";

export const ItemSearchSection = () => {
	const { EQM4010_R01Filter, setEQM4010_R01Filter } = useEQM4010_R01Store();
	const { compCdList, moldClassList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'moldCd',
			category: '금형코드',
			focusId: 'moldCd_search',
			responseMapping: {
				moldCd: 'moldCd',
				moldNm: 'moldNm',
			},
			extraFilter: () => ({
				moldClass: EQM4010_R01Filter.moldClass || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: EQM4010_R01Filter,
		setEditData: setEQM4010_R01Filter,
		defaultData: defaultEQM4010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'EQM4010_R01_search',
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={EQM4010_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(item) => setEQM4010_R01Filter({ compCd: item?.compCd || '' })}
			/>
			<SearchDropDownForm
				label="금형구분"
				value={EQM4010_R01Filter.moldClass}
				onChangeItem={(item) => setEQM4010_R01Filter({ moldClass: item?.minorCd || '' })}
				optionList={moldClassList}
			/>
			<SearchDateRangeForm
				label="조회기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={EQM4010_R01Filter.inquiryDt}
				setDateRange={(v) => setEQM4010_R01Filter({ inquiryDt: v })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="금형코드"
				value={EQM4010_R01Filter.moldCd}
				valueLabel={EQM4010_R01Filter.moldNm}
				handleFoucsId="moldCd_search"
				onChange={getFieldHandlers('moldCd').onChange}
				onDoubleClick={getFieldHandlers('moldCd').onDoubleClick}
				onKeyDown={getFieldHandlers('moldCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};
